import env from '../config/env';
import axiosInstance from './';

export default class {
  constructor() {
    this.instance = axiosInstance(env.REACT_APP_EVENTS_ENDPOINT, null);
  }

  getEvents = accountId => this.instance({ url: `/cardapio/contas/${accountId}/eventos` });

  getAccounts = () => this.instance({ url: '/cardapio/contas' });

  getAccount = cnpj => this.instance({ url: `/cardapio/contas?cnpj=${cnpj}` });
}



// WEBPACK FOOTER //
// ./src/services/Events.js